<div class="filtros">
  <mat-form-field appearance="outline" style="width: 100%">
    <mat-label>Buscar</mat-label>
    <input
      matInput
      [(ngModel)]="filtroTexto"
      placeholder="Nome do arquivo ou status"
      (keyup)="aplicarFiltro()"
    />
  </mat-form-field>
</div>

<table mat-table [dataSource]="dataSource" class="cis-default-table" matSort>
  <!-- Nome do Arquivo -->
  <ng-container matColumnDef="nomeArquivo">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Arquivo</th>
    <td mat-cell *matCellDef="let item">{{ item.nomeArquivo }}</td>
  </ng-container>

  <!-- Data de Criação -->
  <ng-container matColumnDef="dataProcessamento">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Data de processamento</th>
    <td mat-cell *matCellDef="let item">
      {{ item.dataProcessamento | date:'dd/MM/yyyy HH:mm' }}
    </td>
  </ng-container>

  <!-- Nome pessoa -->
  <ng-container matColumnDef="nomePessoa">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome pessoa</th>
    <td mat-cell *matCellDef="let item">{{ item.nomePessoa }}</td>
  </ng-container>

  <!-- Status -->
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
    <td mat-cell *matCellDef="let item">
      @if (item.status === 'Pendente' || item.status === 'Em processamento') {
      <span class="status-pill status-pendente">{{item.status}}</span>
      }@else if (item.status === 'Concluido') {
      <span class="status-pill status-active">Concluido</span>
      }@else if (item.status === 'Erro') {
      <span class="status-pill status-erro">Erro</span>
      }
    </td>
  </ng-container>

  <!-- Açoes -->
  <ng-container matColumnDef="acoes">
  <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
  <td mat-cell *matCellDef="let item"> @if (item.status === 'Concluido') {
    <button mat-icon-button 
      type="button" 
      title="Baixar relatório de erros"
      (click)="baixarRelatorio(item.correlationId); $event.stopPropagation()"> <mat-icon>download</mat-icon>
    </button>
    }
  </td>
</ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
  ></tr>
</table>

<div class="paginator-container">
  <p class="contagem-texto">{{ textoContagem }}</p>

  <mat-paginator
    [length]="total"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChange($event)"
  ></mat-paginator>
</div>
